import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Label } from "./Reveal";
import { STATS } from "../data";

export default function Stats() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="stats-section"
      className="bg-obsidian py-24 lg:py-32 border-b border-border"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative h-[420px] lg:h-[560px] overflow-hidden border border-border">
          <motion.img
            style={{ y: imgY, scale: 1.15 }}
            src="https://images.pexels.com/photos/6195277/pexels-photo-6195277.jpeg"
            alt="Professional cleaning team in uniform"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-obsidian/20" />
          <div className="absolute top-6 left-6 border border-acid px-4 py-2 bg-obsidian/70 backdrop-blur">
            <span className="text-acid text-xs uppercase tracking-[0.2em] font-bold">
              Since 2013
            </span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <Label>The Numbers</Label>
            <h2 className="font-display uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[0.95] text-white">
              Trusted by the<br />names that matter.
            </h2>
            <p className="mt-8 max-w-lg text-zinc-400 font-light leading-relaxed">
              Pure Space Cleaning has operated across Brisbane for over a decade,
              scaling with corporate towers, distribution centres and business
              parks throughout South East Queensland.
            </p>
          </Reveal>

          <div className="mt-14 grid grid-cols-2 gap-px bg-border border border-border">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08} className="bg-obsidian">
                <div className="p-8">
                  <div className="font-display text-5xl lg:text-6xl text-white tracking-tight">
                    {s.value}
                  </div>
                  <div className="mt-3 text-xs uppercase tracking-[0.2em] text-zinc-500">
                    {s.label}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
